export const resourceInfoData: {
  name: string
  avg: string
  max: string
  delta: string
  location: string
}[] = [
  {
    name: 'TiDB Memory Usage',
    avg: 'TiDB_memory_avg:total.values.mean',
    max: 'TiDB_memory_max:total.values.mean',
    delta: 'TiDB_memory_delta:total.values.mean',
    location: 'TiDB-Details --> Server --> Memory Usage'
  },
  {
    name: 'TiDB CPU Usage',
    avg: 'TiDB_CPU_avg:total.values.mean',
    max: 'TiDB_CPU_max:total.values.mean',
    delta: 'TiDB_CPU_delta:total.values.mean',
    location: 'TiDB-Details --> Server --> CPU Usage'
  },
  {
    name: 'TiKV Memory Usage',
    avg: 'TiKV_memory_avg:total.values.mean',
    max: 'TiKV_memory_max:total.values.mean',
    delta: 'TiKV_memory_delta:total.values.mean',
    location: 'TiKV-Details --> Cluster--> Memory'
  },
  {
    name: 'TiKV CPU Usage',
    avg: 'TiKV_CPU_avg:total.values.mean',
    max: 'TiKV_CPU_max:total.values.mean',
    delta: 'TiKV_CPU_delta:total.values.mean',
    location: 'TiDB-Details --> Cluster --> CPU Usage'
  },
  {
    name: 'TiKV MBPS(read+write) Usage',
    avg: '[manual]',
    max: '[manual]',
    delta: '[manual]',
    location: '[manual] Node-Info --> Disk --> Disk Bandwidth'
  },
  {
    name: 'TiKV IOPS(read+write) Usage',
    avg: '[manual]',
    max: '[manual]',
    delta: '[manual]',
    location: '[manual] Node-Info --> Disk --> Disk IOPS'
  },
  {
    name: 'TiKV Disk Usage Ratio',
    avg: 'TiKV_disk_usage_avg:total.values.mean',
    max: 'TiKV_disk_usage_max:total.values.mean',
    delta: 'TiKV_disk_usage_delta:total.values.mean',
    location: 'TiKV-Details --> Cluster --> Store size'
  },
  {
    name: 'TiKV Store Available Ratio',
    avg: 'TiKV_store_available_ratio_avg:total.values.mean',
    max: 'TiKV_store_available_ratio_max:total.values.mean',
    delta: 'NA',
    location: 'PD --> Statistics - Balance --> Store available ratio'
  },
  {
    name: 'TiKV Storage Consumption Rate',
    avg: '[manual]',
    max: '[manual]',
    delta: '[manual]',
    location: `[manual] Overview --> PD --> Current Storage Size<br />
    - Concern1: run out of 100% TiKV<br />
    - Concern2: run out of 80% TiKV<br />
    - Concern3: Reservation of Free Space to allow data to be re-balanced in case of loss of one TiKV in the availability zone.<br />`
  },
  {
    name: 'PD Memory(leader) Usage',
    avg: 'PD_memory_usage_avg:total.values.mean',
    max: 'PD_memory_usage_max:total.values.mean',
    delta: 'PD_memory_usage_delta:total.values.mean',
    location: 'PD --> Cluster --> Memory Usage'
  },
  {
    name: 'PD CPU(leader) Usage',
    avg: 'PD_CPU_usage_max:total.values.mean',
    max: 'NA',
    delta: 'NA',
    location: 'PD --> Cluster --> CPU Usage'
  },
  {
    name: 'TiFlash CPU Usage',
    avg: 'TiFlash_CPU_usage_avg:total.values.mean',
    max: 'TiFlash_CPU_usage_max:total.values.mean',
    delta: 'TiFlash_CPU_usage_delta:total.values.mean',
    location: 'TiFlash-Summary --> Server --> CPU Usage'
  },
  {
    name: 'TiFlash Memory Usage',
    avg: 'TiFlash_memory_usage_avg:total.values.mean',
    max: 'TiFlash_memory_usage_max:total.values.mean',
    delta: 'TiFlash_memory_usage_delta:total.values.mean',
    location: 'TiFlash-Summary --> Server --> Memory Usage'
  },
  {
    name: 'TiFlash Disk Usage Ratio',
    avg: 'TiFlash_disk_usage_avg:total.values.mean',
    max: 'TiFlash_disk_usage_max:total.values.mean',
    delta: 'TiFlash_disk_usage_delta:total.values.mean',
    location: 'TiFlash-Summary --> Server --> Store size'
  },
  {
    name: 'TiFlash Disk Inode Usage',
    avg: '[manual]',
    max: '[manual]',
    delta: '[manual]',
    location: '[manual] Node-Info --> Disk --> PVC inode usage'
  },
  {
    name: 'Network(Client)',
    avg: 'TiDB_client_network_avg:total.values.mean',
    max: 'TiDB_client_network_max:total.values.mean',
    delta: 'TiDB_client_network_delta:total.values.mean',
    location: 'TiDB-Details --> Server --> Client Data Traffic'
  },
  {
    name: 'Network(TiKV)',
    avg: '[manual]',
    max: '[manual]',
    delta: '[manual]',
    location:
      '[manual] Node-Info --> Network --> Network Received+ Network Transmitted'
  }
]
